/**
 * Feedback (satisfaction survey) page
 * Shows anonymous feedback list first, then a button to open the form for own feedback.
 * No bottom nav; back button returns to previous page.
 */

import { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { ArrowLeft, MessageSquarePlus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { FeedbackForm } from './FeedbackForm';
import { AnonymousFeedbackList } from './AnonymousFeedbackList';

export function FeedbackPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const source = searchParams.get('source') ?? undefined;
  const [showForm, setShowForm] = useState(false);

  return (
    <div className="min-h-screen p-6 space-y-6">
      <div className="flex items-center gap-3 -mt-1 mb-2">
        <Button
          type="button"
          variant="ghost"
          size="icon"
          onClick={() => navigate(-1)}
          aria-label="กลับหน้าก่อนหน้า"
          className="shrink-0"
        >
          <ArrowLeft className="h-5 w-5" />
        </Button>
      </div>

      <header className="space-y-2">
        <h1 className="text-3xl font-bold text-violet-900 dark:text-violet-100">
          แบบประเมินความพึงพอใจ
        </h1>
        <p className="text-slate-600 dark:text-slate-400 text-md">
        เราทีมพัฒนาแอป Quran Assistant 🤓 <br /> รู้สึกดีใจที่ได้เป็นผู้ช่วย สร้างประสบการณ์ในเดือนเราะมะฎอนของพี่น้องให้มีความหมายมากขึ้น 😊
        </p>
      </header>

      <AnonymousFeedbackList />

      {showForm ? (
        <FeedbackForm source={source} />
      ) : (
        <Card>
          <CardContent className="pt-6">
            <Button
              type="button"
              variant="default"
              className="w-full gap-2"
              size="lg"
              onClick={() => setShowForm(true)}
            >
              <MessageSquarePlus className="h-5 w-5" />
              ส่งแบบประเมินของฉัน
            </Button>
          </CardContent>
        </Card>
      )}
    </div>
  );
}

export default FeedbackPage;
